import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import { ProductsProvider } from './context/products_context';
import { FilterProvider } from './context/filter_context';
import { CartProvider } from './context/cart_context';
import { UserProvider } from './context/user_context';
import { OrderProvider } from './context/order_context';
import { LanguageProvider } from './context/language_context';
import { WishlistProvider } from './context/wishlist_context';

ReactDOM.render(
  <HelmetProvider>
    <LanguageProvider>
      <UserProvider>
        <ProductsProvider>
          <FilterProvider>
            <CartProvider>
              <WishlistProvider>
                <OrderProvider>
                  <App />
                </OrderProvider>
              </WishlistProvider>
            </CartProvider>
          </FilterProvider>
        </ProductsProvider>
      </UserProvider>
    </LanguageProvider>
  </HelmetProvider>,
  document.getElementById('root')
);
